import { GridColumns, DataGrid } from '@material-ui/data-grid';
import React from 'react';
import { Row, Col } from 'react-bootstrap';
import {
  ResponsiveContainer,
  PieChart,
  Pie,
  Cell,
  Legend,
  Tooltip,
} from 'recharts';
import { Container } from './styles';
import { useRelatorioRaioXVendas } from '../../RelatorioRaioXVendasContext';
import { moneyFormat } from '~/utils/functions';
import { CircularProgress } from '@material-ui/core';
import CustomDataGrid from '../../components/CustomDataGrid';

const colors = [
  '#FF6361',
  '#0088FE',
  '#FF8042',
  '#FFA600',
  '#00C49F',
  '#FFB5B8',
  '#A28BFE',
  '#FFD700',
];

const AbaCaixa: React.FC = () => {
  const { caixaInfos, caixaChartInfos, loading } = useRelatorioRaioXVendas();

  const columnsCaixa = [
    {
      field: 'id',
      headerName: 'id',
      hide: true,
      width: 100,
    },
    {
      field: 'cod_loja',
      headerName: 'Loja',
      type: 'string',
      width: 70,
    },
    {
      field: 'num_pdv',
      headerName: 'Caixa',
      type: 'string',
      width: 70,
    },
    {
      field: 'val_total',
      headerName: 'Val. Venda',
      type: 'number',
      width: 120,
      renderCell: (row: any) => {
        return `R$ ${moneyFormat(row.val_total || 0)}`;
      },
    },
    {
      field: 'percentual_participacao',
      headerName: 'Participação',
      type: 'string',
      width: 70,
      renderCell: (row: any) => {
        const percentualParticipacao = row.percentual_participacao.trim();
        return `${percentualParticipacao || 0}%`;
      },
    },
    {
      field: 'val_margem_contribuicao',
      headerName: 'Mg Contr.',
      type: 'number',
      width: 70,
      renderCell: (row: any) => {
        return `R$ ${row.val_margem_contribuicao || 0}`;
      },
    },
  ];

  const formatCurrency = (value: number) => {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    }).format(value);
  };

  return (
    <Container>
      <Row>
        <Col sm={12} md={6}>
          <ResponsiveContainer width="100%" height={350}>
            {loading ? (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '100%',
                }}
              >
                <CircularProgress size={35} style={{ color: '#8850BF' }} />
              </div>
            ) : caixaChartInfos.length === 0 ? (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '100%',
                }}
              >
                <p style={{ textAlign: 'center', fontSize: '18px' }}>
                  Nenhum registro encontrado.
                </p>
              </div>
            ) : (
              <PieChart>
                <Pie
                  data={caixaChartInfos || []}
                  dataKey="val_total"
                  nameKey="num_pdv"
                  cx="50%"
                  cy="50%"
                  outerRadius={70}
                  fill="#8884d8"
                  label={({ value }) => formatCurrency(value)}
                >
                  {caixaChartInfos.map((entry: any, index: any) => (
                    <Cell key={`cell-${entry.num_pdv}`} fill={colors[index]} />
                  ))}
                </Pie>
                <Tooltip formatter={(value: number) => formatCurrency(value)} />
                <Legend />
              </PieChart>
            )}
          </ResponsiveContainer>
        </Col>
        <Col sm={12} md={6}>
          <CustomDataGrid
            loading={loading}
            rows={caixaInfos}
            columns={columnsCaixa}
            isEmptyLineMessage
            emptyLineMessage="Nenhum registro encontrado."
          />
        </Col>
      </Row>
    </Container>
  );
};

export default AbaCaixa;
